import { Component, DoCheck } from '@angular/core';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';
import { OAuthService } from '../../../../../../../services/oauth.service';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';

@Component({
    selector: 'hubspot-connector-panel',
    templateUrl: './hubspot.connector.panel.html'
})
export class HubSpotConnectorPanel extends ACDATAConnectorPanel implements DoCheck {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@HubSpot',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.HubSpotInfo',
            ControlType: HubSpotConnectorPanel,
            Default: null
        };
    }

    ShowAdvancedScopes = false;

    private _defaultsApplied = false;

    // Read-only display in UI (CData default required scopes)
    requiredScopes =
        'oauth crm.lists.read crm.lists.write ' +
        'crm.objects.companies.read crm.objects.companies.write ' +
        'crm.objects.contacts.read crm.objects.contacts.write ' +
        'crm.objects.deals.read crm.objects.deals.write ' +
        'crm.objects.owners.read ' +
        'crm.schemas.deals.read crm.schemas.deals.write ' +
        'crm.schemas.companies.read crm.schemas.companies.write ' +
        'crm.schemas.contacts.read crm.schemas.contacts.write';

    optionalScopes =
        'content social automation files forms timeline e-commerce business-intelligence tickets sales-email-read ' +
        'crm.objects.custom.read crm.objects.custom.write crm.schemas.custom.read ' +
        'crm.objects.feedback_submissions.read crm.objects.goals.read ' +
        'crm.objects.leads.read crm.objects.leads.write ' +
        'crm.objects.orders.read crm.objects.orders.write crm.schemas.orders.read crm.schemas.orders.write ' +
        'conversations.read conversations.write ' +
        'crm.objects.users.read settings.users.read settings.users.teams.read ' +
        'crm.objects.quotes.read crm.objects.quotes.write crm.schemas.quotes.read ' +
        'marketing.campaigns.read marketing.campaigns.write ' +
        'crm.objects.invoices.read crm.objects.invoices.write ' +
        'crm.objects.appointments.read crm.objects.appointments.write crm.schemas.appointments.read crm.schemas.appointments.write ' +
        'crm.objects.courses.read crm.objects.courses.write crm.schemas.courses.read crm.schemas.courses.write ' +
        'crm.objects.listings.read crm.objects.listings.write crm.schemas.listings.read crm.schemas.listings.write ' +
        'crm.objects.services.read crm.objects.services.write crm.schemas.services.read crm.schemas.services.write ' +
        'communication_preferences.read_write communication_preferences.statuses.batch.write ' +
        'crm.objects.marketing_events.read crm.objects.marketing_events.write ' +
        'crm.objects.subscriptions.read crm.objects.subscriptions.write crm.schemas.subscriptions.read crm.schemas.subscriptions.write';

    constructor(private service: OAuthService) {
        super();
    }

    ngDoCheck(): void {
        // Apply defaults once, as soon as Settings exists
        if (!this._defaultsApplied && this.Settings) {
            this.ensureDefaults();
            this._defaultsApplied = true;
        }
    }

    private hasScopeOverrides(): boolean {
        const req = (this.Settings?.['OAuthRequiredScopesOverride'] ?? '').toString().trim();
        const opt = (this.Settings?.['OAuthOptionalScopesOverride'] ?? '').toString().trim();
        return req.length > 0 || opt.length > 0;
    }

    private ensureDefaults(): void {
        if (!this.Settings) return;

        if (!this.Settings['AuthScheme']) this.Settings['AuthScheme'] = 'OAuth';
        if (!this.Settings['Schema']) this.Settings['Schema'] = 'HubSpotV4';

        if (this.Settings['SendOptionalScopes'] === undefined || this.Settings['SendOptionalScopes'] === null) {
            this.Settings['SendOptionalScopes'] = false;
        }

        // If overrides exist, force Advanced open
        if (this.hasScopeOverrides()) {
            this.ShowAdvancedScopes = true;
        }
    }

    // NEW: click handler that can block the toggle without "abgehackt"
    onAdvancedScopesClick(ev: MouseEvent): void {
        this.ensureDefaults();

        const wantsToClose = this.ShowAdvancedScopes === true;

        if (wantsToClose && this.hasScopeOverrides()) {
            ev.preventDefault();
            ev.stopPropagation();
            alert('Advanced Scopes können nicht deaktiviert werden, solange Overrides gesetzt sind. Bitte Overrides zuerst leeren.');
            return;
        }

        this.ShowAdvancedScopes = !this.ShowAdvancedScopes;
        this.onChange();
    }

    onAuthSchemeChanged(): void {
        if (!this.Settings) return;

        this.ensureDefaults();

        if (this.Settings['AuthScheme'] === 'PrivateAppToken') {
            // Reset OAuth fields
            this.Settings['ClientId'] = null;
            this.Settings['ClientSecret'] = null;

            // OAuth-only fields not relevant
            this.Settings['SendOptionalScopes'] = null;
            this.Settings['OAuthRequiredScopesOverride'] = null;
            this.Settings['OAuthOptionalScopesOverride'] = null;

            this.ShowAdvancedScopes = false;
        } else {
            // Reset token field
            this.Settings['PrivateAppToken'] = null;

            // Ensure defaults
            if (this.Settings['SendOptionalScopes'] === undefined || this.Settings['SendOptionalScopes'] === null) {
                this.Settings['SendOptionalScopes'] = false;
            }
        }

        this.onChange();
    }

    authenticate(): void {
        // OAuth only (Button ist bei PrivateAppToken ausgeblendet)
        if (this.DataSource && this.DataSource.SID) {
            this.ensureDefaults();

            this.service.GetOAuthURL(this.DataSource.SID, 'CData').subscribe(x => {
                if (x) {
                    window.open(x, '_blank');
                }
            });
        }
    }
}